export default __webpack_public_path__ + "static/media/linkedin.311b09d7.svg";